import React from 'react'
import './Footer.css'

export default function Footer() {
  return (
    <div className="footer">
      <h4>&copy; Designed By <a href="https://reddyvenkatkalyan.vercel.app/" target="_blank" className="footer-link" rel="noopener noreferrer">Reddy Venkat Kalyan</a> Using React!</h4>
      <h4>All Rights Reserved!</h4>
    </div>
  );
  
}
